// extracted by mini-css-extract-plugin
module.exports = {"vWhite":"#fff","vUiHue":"#ddd","skeleton-box":"Skeleton__skeleton-box___eyrvj","roundBorder":"Skeleton__roundBorder___kp5qe","shimmer":"Skeleton__shimmer___xu04X"};